import type { ReactNode } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';

/**
 * Phone (< 768 px): the open chat covers the list full screen. A real modal:
 * the list behind it is hidden from screen readers and the keyboard, Escape
 * and the back arrow return to the list (which stays mounted, so filters and
 * scroll position survive).
 */
export function MobileChatDialog({ onClose, children }: { onClose: () => void; children: ReactNode }) {
  return (
    <DialogPrimitive.Root open onOpenChange={(open) => !open && onClose()}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Content
          data-testid="mobile-chat"
          aria-describedby={undefined}
          // Radix focuses the first control (the back arrow); `focus=composer`
          // moves the cursor into the reply box once the chat has loaded.
          className="fixed inset-0 z-40 flex flex-col bg-card focus:outline-none"
        >
          <DialogPrimitive.Title className="sr-only">Verlauf</DialogPrimitive.Title>
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export default MobileChatDialog;
